import { useUIStore } from '~/store/ui';

export const useClientMode = () => {
  const uiStore = useUIStore();
  const isOn = computed(() => uiStore.clientMode);
  const toggle = () => uiStore.toggleClientMode();
  const set = (value: boolean) => uiStore.setClientMode(value);
  return { isOn: readonly(isOn), toggle, set };
};
